<template>
  <div class="orderDetail">
    <el-card class="box-card">
      <div class="top">
        <div class="top-left">
          <img src="@/assets/imgs/brandReview/weifukuan.png" alt />
        </div>
        <div class="top-right">
          <h3>{{orderData.orderStatusName}}</h3>
          <div class="money">
            <span class="text">实付金额：</span>
            <span class="num">
              <b>{{orderData.payTotalSum}}</b>元
            </span>
          </div>
          <p class="tips">
            请在
            <span>2020-07-23 21:00:00</span>前完成支付，逾期订单及对应优惠将自动取消。
          </p>
        </div>
        <div class="btnBox" v-show="orderData.orderStatus=== 1">
          <span
            class="payment"
            @click="$router.push(`/brandReview/cashier?payNo=${orderData.orderNo}&payMoney=${orderData.payTotalSum}&serveItem=${orderData.channelItemName}`)"
          >立即付款</span>
          <span class="cancel" @click="deleteOrder(orderData.orderNo)">取消订单</span>
        </div>
      </div>
      <div class="line"></div>
      <div class="middle">
        <div class="middle-left">
          <p class="form-item">
            <span class="item-lable">订单号</span>
            <span class="item-content">{{orderData.orderNo}}</span>
          </p>
          <p class="form-item">
            <span class="item-lable">订单创建人</span>
            <span class="item-content">{{orderData.channelUserId}}</span>
          </p>
          <p class="form-item">
            <span class="item-lable">付款方式</span>
            <span class="item-content">00000</span>
          </p>
          <p class="form-item">
            <span class="item-lable">备注</span>
            <span class="item-content">{{orderData.notes}}</span>
          </p>
        </div>
        <div class="middle-right">
          <p class="form-item">
            <span class="item-lable">订单类型</span>
            <span class="item-content">0000</span>
          </p>
          <p class="form-item">
            <span class="item-lable">创建时间</span>
            <span
              class="item-content"
            >{{orderData.created_at?formatTime(orderData.created_at):'--'}}</span>
          </p>
          <p class="form-item">
            <span class="item-lable">付款时间</span>
            <span class="item-content">{{orderData.payTime?formatTime(orderData.payTime):'--'}}</span>
          </p>
        </div>
      </div>
      <div class="bottom">
        <h3>订单信息</h3>
        <el-table :data="tableData" style="width: 100%" :header-cell-style="tableClass">
          <el-table-column prop="orderNo" label="子订单号"></el-table-column>
          <el-table-column prop="channelItemName" label="产品"></el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>商标类别:</span>
              <!-- <span
                v-for="(item,index) in scope.row.orderSnapshot.tradeType"
                :key="index"
              >第{{item.code}}类 {{item.name}}</span>-->
              <span>第{{scope.row.orderSnapshot.tradeType||'--'}}类</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="单价"></el-table-column>
          <el-table-column prop="quantity" label="数量"></el-table-column>
          <el-table-column prop="payType" label="付费">
            <template>0000</template>
          </el-table-column>
          <el-table-column prop="totalSum" label="订单金额"></el-table-column>
        </el-table>
        <div class="payMoney">
          <span class="text">订单实付</span>
          <span class="num">{{orderData.payTotalSum}}元</span>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { getOrderDetails, delOrder } from "@/api/fill.js";
export default {
  data() {
    return {
      // 订单号
      orderNo: "",
      // 订单数据
      orderData: {},
      // 表格数据
      tableData: [],
    };
  },
  computed: {
    tableClass() {
      return { background: "rgba(247,252,255,1)", border: "none" };
    },
    // 格式时间
    formatTime() {
      return function (timeStr) {
        let time = "";
        if (timeStr.indexOf("T") !== -1) {
          let tmpStr = timeStr.split("T");
          let tmpYMD = tmpStr[0];
          let tmpHMS = tmpStr[1].split(".")[0];
          time = tmpYMD + " " + tmpHMS;
        } else {
          time = timeStr;
        }
        return time;
      };
    },
  },
  methods: {
    // 取消订单
    deleteOrder(orderNo) {
      let params = {
        orderNo,
      };
      delOrder(params).then((res) => {
        if (res.status == 0) {
          this.$message({
            type: "success",
            message: "取消订单成功,1秒后返回上一页",
            center: true,
            duration: 1000,
            onClose: this.handleClose,
          });
        } else {
          this.$message.error("订单取消失败");
        }
      });
    },
    handleClose() {
      this.$router.push("/brandReview/brandController/myOrder");
    },
  },
  created() {
    // console.log(this.$route.query);
    this.orderNo = this.$route.query.orderNo;
    // 设置初始参数
    let params = {
      orderNo: this.orderNo, // N 渠道订单号
    };
    // 请求数据
    getOrderDetails(params).then((res) => {
      if (res.status == 0) {
        // console.log(res);
        this.tableData.push(res.data);
        this.orderData = res.data;
        let tmpLi = JSON.parse(this.tableData[0].orderSnapshot);
        // console.log(tmpLi,'000000000000')
        this.tableData[0].orderSnapshot = tmpLi;
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.orderDetail {
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  padding: 20px;
  .box-card {
    width: 100%;
    height: 100%;
    border-radius: 0px;
    overflow: auto;
    .top {
      width: 100%;
      height: 135px;
      .top-left {
        margin-right: 20px;
        float: left;
        img {
          width: 66px;
          height: 55px;
        }
      }
      .top-right {
        float: left;
        width: auto;
        h3 {
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 119, 36, 1);
        }
        .money {
          .text {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }
          .num {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #ff7724;
            b {
              font-size: 34px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: #ff7724;
            }
          }
        }
        .tips {
          font-size: 12px;
          color: #888888;
          span {
            font-size: 12px;
            color: #ff7724;
          }
        }
      }
      .btnBox {
        float: right;
        margin-right: 0;
        margin-top: 85px;
        span {
          display: inline-block;
          width: 112px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
        }
        .payment {
          background-color: #ff7724;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          border: 1px solid #ff7724;
          margin-right: 20px;
        }
        .cancel {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          border: 1px solid #dddddd;
        }
      }
    }
    .line {
      width: 100%;
      border: 1px solid #dddddd;
    }
    .middle {
      width: 100%;
      height: 161px;
      margin-top: 20px;
      display: flex;
      div {
        width: 50%;
        display: inline-block;
        .form-item {
          width: 100%;
          height: 17px;
          line-height: 17px;
          font-size: 12px;
          margin-bottom: 15px;
          .item-lable {
            width: 60px;
            display: inline-block;
            margin-right: 20px;
            color: #888888;
          }
          .item-content {
            width: auto;
            color: #000000;
          }
        }
      }
      .middle-left {
        width: 50%;
        height: 100%;
      }
      .middle-right {
        width: 50%;
        height: 100%;
      }
    }
    .bottom {
      width: 100%;
      height: 147px;
      h3 {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 1);
      }
      .payMoney {
        margin-top: 20px;
        width: 100%;
        text-align: end;
        height: 30px;
        line-height: 30px;
        .text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          display: inline-block;
          margin-right: 20px;
        }
        .num {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 119, 36, 1);
        }
      }
    }
  }
}
</style>